import React,{Component} from 'react';
import './Account.css';

// redux
import { connect } from 'react-redux';
import _ from 'lodash';
import { bannerImage, logo } from '../../theme/images';
import routes from '../../utils/routes';
import User from '@acri-tools/react-tools/components/User/User';
import Footer from '../../components/Footer/Footer';
import Page from '@acri-tools/react-tools/components/Page/Page';
import UpdateUserPassword from '@acri-tools/react-tools/components/UpdateUserPassword/UpdateUserPassword';
import UpdateUserEmail from '@acri-tools/react-tools/components/UpdateUserEmail/UpdateUserEmail';

interface Props{
    history?:any,
    // redux
    login?:any
}

interface State{
    user?: any
    updateUser?: any
    userUpdates: any
}

class Account extends Component<Props,State>{

    constructor(props:Props){
        super(props);
        this.state={
            userUpdates: {},
        }
    }

    componentDidMount(){
        let user = _.cloneDeep(this.props.login.user);
        delete user.password;
        this.setState({
            user: _.cloneDeep(user),
            updateUser: _.cloneDeep(user),
        })
    }

    render(){
        return (
        <Page 
            id="account"
            title="Account"
            footer={<Footer />}
            banner={{
                topBar:{
                    disableLogo: true,
                    routes
                },
                bannerImage: bannerImage
            }}
        >
            <div className="page-content">
                <div className="row-centered-column">
                    <div className="content-div">
                        {
                            this.state.updateUser &&
                            this.state.userUpdates &&

                            <>
                            <div className="content-div">
                                <User update/>
                            </div>  

                            <div className="content-div">
                                <UpdateUserPassword/>
                            </div>  

                            <div className="content-div">
                                <UpdateUserEmail/>
                            </div>  
                        </>
                        }
                    </div>
                </div>
            </div>
        </Page>
        );
    } 
};


const mapStateToProps = (state: any) => {
    return {
        login: state.login,
        notifications: state.notifications,
    }
}

export default connect(mapStateToProps)(Account);
